// removed by extract-text-webpack-plugin
module.exports = {"root":"BooleanFilter__root__38NYb","filtersWrapper":"BooleanFilter__filtersWrapper__12JAN","footer":"BooleanFilter__footer__1i3mF","input":"BooleanFilter__input__2cd1o","stepper":"BooleanFilter__stepper__D1pN3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/BooleanFilter/BooleanFilter.css
// module id = 1418
// module chunks = 0